import { PAIPAN } from "../core/paipan";
import { WUXING } from "../core/wuxing";
import { UTILS } from "../../utils";
import { MOMENT_TIME } from "../../momenttime";
import { FORMAT } from "../core/format";

var CALENDAR_DATA_MANAGER = {
    /**
     * 根据当前时间获取时间信息
     * @param {当前时间} curDate 
     */
    getCalendarInfoDataByDate(curDate) {
        // console.error('curDate-------', curDate)
        var year = curDate.getFullYear(), month = curDate.getMonth()+1, day = curDate.getDate(), week = curDate.getDay(),
            nowDate = new Date(), hour = nowDate.getHours(), minute = nowDate.getMinutes(),
            dateStr = year + '/' + UTILS.getTimeStrByInt(month) + '/' + UTILS.getTimeStrByInt(day) + ' ' + UTILS.getTimeStrByInt(hour) + ':' + UTILS.getTimeStrByInt(minute) + ':00';
        var lunarTime = PAIPAN.Solar2Lunar(year, month, day),
            lunarDay = FORMAT.getChineseWordByNumber('month', lunarTime.m) + FORMAT.getChineseWordByNumber('day', lunarTime.d);
        var time = parseInt(new Date(dateStr).getTime() / 1000);
        // var time = MOMENT_TIME.getUnixTimeByTimeStr(dateStr);
        var baziData = PAIPAN.GetInfo(0, time, 1), sizhu = [], textArr = ['年', '月', '日', '时'];
            for(var i = 0; i < 4; i++) {
                sizhu.push({text: textArr[i], gan: FORMAT.getTianGanWordDataByIndex(baziData.tg[i]), zhi: FORMAT.getDiZhiWordDataByIndex(baziData.dz[i])});
            }
        var jieqi = [], beg = baziData.jieqi.beg, mid = baziData.jieqi.mid;
            jieqi.push(beg.name + ' ' + UTILS.getTimeStrByInt(beg.time[2]) + '日 ' + UTILS.getTimeStrByInt(beg.time[3]) + ':' + UTILS.getTimeStrByInt(beg.time[4]));
            jieqi.push(mid.name + ' ' + UTILS.getTimeStrByInt(mid.time[2]) + '日 ' + UTILS.getTimeStrByInt(mid.time[3]) + ':' + UTILS.getTimeStrByInt(mid.time[4]));
        var resultData = Object.assign({}, {
            y: year, m: month, d: day, 
            week: UTILS.getWeekStrByInt(week),
            date: lunarDay,
            rigan: baziData.tg[2],
            sizhu: sizhu,
            yGZ: sizhu[1].gan.text+sizhu[1].zhi.text,
            jieqi: jieqi
        });
        console.log('getCalendarInfoDataByDate-----', dateStr, resultData)
        return resultData;
    },
    /**
     * 获取古历节气列表数据
     * @param {当前列表} list 
     */
    getCalendarJieQiListByList(list) {
        var resultList = [];
        _.each(list, (data => {
            resultList.push({
                g: WUXING.getWuXingEnByIndex(WUXING.getTianGanXingByIndex(data.g)),
                z: WUXING.getWuXingEnByIndex(WUXING.getDiZhiXingByIndex(data.z)),
                gan: data.gan,
                zhi: data.zhi,
                msg: data.msg,
                jieqi1: {
                    title: data.jieqi[0].name,
                    timeStr: UTILS.getTimeStrByArr(data.jieqi[0].time)
                },
                jieqi2: {
                    title: data.jieqi[1].name,
                    timeStr: UTILS.getTimeStrByArr(data.jieqi[1].time)
                }
            });
        }))
        console.log('getCalendarJieQiListByList------', resultList)
        return resultList;
    },
    /**
     * 根据日干获取时辰列表
     * @param {日干} rigan 
     */
    getCalendarHourArrayByRigan(rigan) {
        var arr = PAIPAN.getLiuRISLiuShi(rigan);
        var resultArr = [];
        for (var i = 0; i < arr.length; i++) {
            var data = {
                id: (arr[i].beg + arr[i].end + (i + 1) * 100 + i),
                index: i,
                ganzhi: arr[i].msg,
                type: 'liushi',
                title: [(arr[i].beg + '-' + arr[i].end)],
                begTime: arr[i].beg,
                key: rigan.toString() + arr[i].beg.toString() + arr[i].end.toString(),
                gan: FORMAT.getTianGanWordDataByIndex(arr[i].g),
                ganCang: FORMAT.getHideArrDataByIndex('tiangan', arr[i].g, rigan),
                zhi: FORMAT.getDiZhiWordDataByIndex(arr[i].z),
                zhiCang: FORMAT.getHideArrDataByIndex('dizhi', arr[i].z, rigan),
                choosed: false
            }
            resultArr.push(data);
        }
        console.log('getCalendarHourArrayByRigan-----', rigan, resultArr)
        return resultArr;
    },
    /**
     * 更新时辰列表里的当前选中状态
     * @param {源数据} origiList 
     * @param {选中数据} data 
     */
    updateCalendarHourArrayChoosedStatus(origiList, data) {
        _.forEach(origiList, oData => {
            origiList[oData.index] = Object.assign(oData, {
                choosed: oData.index == data.index ? true : false
            })
        });
        return origiList;
    }
}


export {
    CALENDAR_DATA_MANAGER
}